import { subdomainAtom } from '@app/state/subdomainAtom'
import { checkIsPublicRoute } from '@app/utils/checkIsPublicRoute'
import { useSetAtom } from 'jotai'
import { useEffect } from 'react'

export const PUBLIC_PATHS = [/^\/risk\/stories\/[^/]+\/[^/]+\/view(\/.*)?$/] as const

export function useSubDomain() {
  const setSubdomain = useSetAtom(subdomainAtom)
  useEffect(() => {
    const safeDomain = import.meta.env.VITE_SAFE_DOMAIN

    if (!safeDomain) return

    const hostname = window.location.hostname
    if (!hostname.endsWith(safeDomain)) return

    const subdomain = hostname.substring(0, hostname.indexOf(safeDomain) - 1)
    if (!subdomain) return // Keep subdomain null if on a safedomain

    // Subdomain always takes precedence - set both localStorage and atom
    setSubdomain(subdomain)
    localStorage.setItem('client_name', subdomain)
  }, [setSubdomain])

  const isPublic = checkIsPublicRoute(window.location.pathname)

  return { isPublic }
}
